import React from 'react';
import { IconFiveFill, IconFourFill, IconOneFill, IconThreeFill, IconTwoFill, } from '../../../icons';
export const IconNumberFill = ({ number, size, fillColor, }) => {
    switch (number) {
        case 1:
            return React.createElement(IconOneFill, { size: size, fill: fillColor });
        case 2:
            return React.createElement(IconTwoFill, { size: size, fill: fillColor });
        case 3:
            return React.createElement(IconThreeFill, { size: size, fill: fillColor });
        case 4:
            return React.createElement(IconFourFill, { size: size, fill: fillColor });
        case 5:
            return React.createElement(IconFiveFill, { size: size, fill: fillColor });
        default:
            return null;
    }
};
